import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from "../../../i18n/LanguageContext";

/**
 * YouTubeAudioPlayer
 * @param videoId - the YouTube video ID
 */
const YouTubeAudioPlayer = ({ videoId }) => {
  const { t } = useLanguage();
  const playerRef = useRef(null);
  const [isReady, setIsReady] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [meta, setMeta] = useState({ title: "", thumbnail: "" });

  // Load metadata (title + thumbnail)
  useEffect(() => {
    console.log("videoId", videoId);
    fetch(
      `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=${process.env.REACT_APP_YOUTUBE_API_KEY}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.items && data.items.length > 0) {
          const snip = data.items[0].snippet;
          setMeta({
            title: snip.title,
            thumbnail: snip.thumbnails.medium.url,
          });
        }
      });
  }, [videoId]);

  // Load YouTube iframe API
  useEffect(() => {
    if (!window.YT) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      window.onYouTubeIframeAPIReady = initPlayer;
      document.body.appendChild(tag);
    } else {
      initPlayer();
    }

    function initPlayer() {
      playerRef.current = new window.YT.Player("yt-audio", {
        height: "0",
        width: "0",
        videoId,
        playerVars: {
          autoplay: 0,
        },
        events: {
          onReady: () => {
            setDuration(playerRef.current.getDuration());
            setIsReady(true);
          },
          onStateChange: (event) => {
            if (event.data === window.YT.PlayerState.PLAYING) {
              setIsPlaying(true);
            } else if (event.data === window.YT.PlayerState.PAUSED) {
              setIsPlaying(false);
            }
          },
        },
      });
    }
  }, [videoId]);

  // Progress updater
  useEffect(() => {
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        const current = playerRef.current.getCurrentTime();
        setProgress(current);
      }, 500);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isPlaying]);

  const playPause = () => {
    if (!isReady) return;
    if (isPlaying) {
      playerRef.current.pauseVideo();
    } else {
      playerRef.current.playVideo();
    }
  };

  const onSeek = (e) => {
    const newTime = e.target.value;
    playerRef.current.seekTo(newTime, true);
    setProgress(newTime);
  };

  return (
    <div
      style={{
        width: 320,
        margin: "20px auto",
        padding: 20,
        border: "1px solid #ccc",
        borderRadius: 8,
        textAlign: "center",
        fontFamily: "sans-serif",
      }}
    >
      {/* hidden player */}
      <div id="yt-audio" style={{ width: 0, height: 0, overflow: "hidden" }} />

      {/* metadata */}
      {meta.thumbnail && (
        <img
          src={meta.thumbnail}
          alt="thumbnail"
          style={{ width: "100%", borderRadius: 8 }}
        />
      )}
      <h4 style={{ marginTop: 10 }}>{meta.title}</h4>

      {/* progress bar */}
      <input
        type="range"
        min="0"
        max={duration}
        value={progress}
        onChange={onSeek}
        style={{ width: "100%" }}
      />
      <div style={{ fontSize: 12 }}>
        {Math.floor(progress)}s / {Math.floor(duration)}s
      </div>

      {/* controls */}
      <button
        onClick={playPause}
        disabled={!isReady}
        style={{
          marginTop: 10,
          padding: "8px 16px",
          background: "#cc0000",
          color: "#fff",
          border: "none",
          borderRadius: 4,
        }}
      >
{isPlaying ? t('pause') : t('play')}
      </button>
    </div>
  );
};

export default YouTubeAudioPlayer;
